<div class="ya-bottomsheet-container ya-typography">
  <ya-bottomsheetclosebottom [bottomSheetRef]="bottomSheetRef"></ya-bottomsheetclosebottom>
  <div class="ya-bottomsheet-content-center">
    <h2 langkey="phFilterLayer_Title">
      <span langkey="phLocationDialog_Title"></span>
    </h2>
    <div class="location-dialog-description">
      <span langkey="phLocationDialog_Description"></span>
    </div>
    <div class="ya-dialog-content">
      <div id="locationList" #locationListView class="ya-dialog-aimation-list">
        <ng-container *ngFor="let location of locations; let i = index">
          <a matRipple matRippleCentered="true" (click)="toggleFilterSelection(location)"
            [ngStyle]="location.topOffset">
            <div class="ya-dialog-list-item">
              <div class="location-item-content">
                <h3>{{location.label}}</h3>
                <span>{{location.street}}</span>
                <span>{{location.zip}} {{location.PostalCode}}</span>
              </div>
              <div class="location-item-selected">
                <ng-container *ngIf="location.selected; then likeTemplate else unLikeTemplate"></ng-container>
                <ng-template #likeTemplate>
                  <div class="inline-icon ya-favorite-svg" inlineSVG="shop-icons.svg#ya-favorite"></div>
                </ng-template>
                <ng-template #unLikeTemplate>
                  <div class="inline-icon ya-favorite-svg" inlineSVG="shop-icons.svg#ya-favorite-border"></div>
                </ng-template>
              </div>
            </div>
          </a>
        </ng-container>
      </div>
    </div>
    <div class="ya-dialog-action">
      <div class="ya-button-container">
        <button mat-flat-button (click)="setUserLocation()"><span
            langkey="phLocationDialog_ConfirmButton"></span></button>
      </div>
    </div>
  </div>
</div>